import { GatewayAvancement } from "@conformite/gateway";
import { axiosInstance } from "@src/data/utils/axiosInstance";

export class GatewayAvancementApi {
  static async getAvancementForAdmin(
    siren: string,
    millesime: number
  ): Promise<GatewayAvancement.AvancementResponseType> {
    const response =
      await axiosInstance.get<GatewayAvancement.AvancementResponseType>(
        `${GatewayAvancement.avancementControllerUrl}/${millesime}/${siren}`
      );
    return response.data;
  }
}
